import callCmAPI from 'services/helpers/call-cm-api'
import { UserSettingsTableNameEnum } from 'types'

/******************
 * Fetch from API *
 ******************/

type SettingsStructure = {
  settings: {
    key: string
    visible: boolean
  }[]
  tableName: UserSettingsTableNameEnum
}

export const getSettingsAll = (id: number | string): Promise<SettingsStructure[]> =>
  callCmAPI(`/user-settings/all/${id}`, {
    method: 'get',
  })
    .then((res) => Promise.resolve(res.data.data)) // :)
    .catch((err) => {
      return Promise.reject(err.response.data.error)
    })
